import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserData } from "../../redux/userActions.js";
import Avatar from "../../pages/avatar/RandomAvatar";

export default function ProfileSettings() {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userDetails) {
      console.log("in user deatils fetch user details", userDetails)
      dispatch(fetchUserData());
    }
  }, [dispatch]);
  useEffect(()=>{
    console.log("user details out ", userDetails)
  },[])
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">

      <div className="max-w-5xl mx-auto">

        {/* Page Title */}
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          Profile Settings
        </h1>

        {/* Profile Header Card */}
        <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8 flex items-center gap-6">

          <div className="w-20 h-20 flex items-center justify-center rounded-full bg-gray-100">
            <Avatar id={userDetails?.fullName} />
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800">
              {userDetails?.fullName || "User Name"}
            </h2>

            <p className="text-gray-500 text-sm">
              {userDetails?.email || "user@email.com"}
            </p>
            {/* 
            <p className="text-xs text-gray-400 mt-1">
              Added by {userDetails?.addedBy || "Admin"}
            </p> */}
          </div>

        </div>

        {/* Account Information */}
        <div className="bg-white rounded-2xl shadow-sm border p-8">

          <h2 className="text-lg font-semibold text-gray-700 mb-6">
            Account Information
          </h2>

          <div className="grid md:grid-cols-2 gap-6">

            {/* Full Name */}
            <div>
              <label className="text-sm text-gray-600 block mb-1">
                Full Name
              </label>

              <input
                type="text"
                disabled
                value={userDetails?.fullName || ""}
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-600 cursor-not-allowed focus:outline-none"
              />
            </div>

            {/* Email */}
            <div>
              <label className="text-sm text-gray-600 block mb-1">
                Email Address
              </label>

              <input
                type="email"
                disabled
                value={userDetails?.email || ""}
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-600 cursor-not-allowed focus:outline-none"
              />
            </div>

            {/* Added By */}
            {/* <div>
              <label className="text-sm text-gray-600 block mb-1">
                Added By
              </label>

              <input
                type="text"
                disabled
                value={userDetails?.addedBy || ""}
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-600 cursor-not-allowed"
              />
            </div> */}

            {/* Phone */}
            {/* <div>
              <label className="text-sm text-gray-600 block mb-1">
                Phone
              </label>

              <input
                type="text"
                disabled
                placeholder="Not available"
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-400 cursor-not-allowed"
              />
            </div> */}

            {/* Role */}
            {/* <div>
              <label className="text-sm text-gray-600 block mb-1">
                Role
              </label>

              <input
                type="text"
                disabled
                placeholder="User role"
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-400 cursor-not-allowed"
              />
            </div> */}

            {/* Account Created */}
            {/* <div>
              <label className="text-sm text-gray-600 block mb-1">
                Account Created
              </label>

              <input
                type="text"
                disabled
                placeholder="Creation date"
                className="w-full border rounded-lg px-4 py-2 bg-gray-100 text-gray-400 cursor-not-allowed"
              />
            </div> */}

          </div>

          {/* Button */}
          {/* <div className="flex justify-end mt-8">
            <button
              disabled
              className="bg-gray-300 text-gray-600 px-6 py-2 rounded-lg cursor-not-allowed"
            >
              Edit Profile (Coming Soon)
            </button>
          </div> */}

        </div>

      </div>
    </div>
  );
}